
<template>
    <v-container fluid>
    <v-card elevation="0" flat tile>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="6">
                        <p class="text-h5">Description</p>
                        </v-col>
                        <v-col md="6" align=right>
                            <v-btn
                            class="button-shadow mr-1"
                            color="secondary"
                            @click="isAddDesc = true"
                            >
                            Add
                            </v-btn>
                            <v-btn
                                class="button-shadow mr-1"
                                to="/employee/list"
                                replace
                                color="primary"
                            >
                                Done
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-data-table
                sort-by="descrank"
                :headers="header_items"
                :items="data_descriptions"
                :items-per-page="500"
                class="elevation-0"
            >
                <template v-slot:top>
                    <v-dialog v-model="isDeleteDesc" width="500">
                        <v-card>
                            <v-card-title> Delete this Description? </v-card-title>
                            <v-card-text>
                            {{ delete_desc.desctype }}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    outlined
                                    @click="isDeleteDesc = false"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    color="secondary"
                                    class="button-shadow"
                                    @click="deleteEmployeeDesc(delete_desc)"
                                    >Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
                <template v-slot:item.descrank="{ item }">
                    <p style="vertical-align: top; height: 100%; padding-top: 10px;">{{ item.descrank }}</p>
                </template> 
                <template v-slot:item.desctype="{ item }">
                    <p class="two-line"><strong>{{ item.desctype }}</strong></p>
                    <p class="two-line" v-html="formatHtmlText(item.desctext)"></p>
                </template>                    
                <template v-slot:item.createdAt="{ item }">
                    {{
                    new Date(item.createdAt).toLocaleString("en-SG", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                    })
                    }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        icon
                        color="primary"
                        @click="editEmployeeDescDialog(item)"
                        >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="primary"
                        @click="deleteEmployeeDescDialog(item)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
    <div>
        <v-dialog
            v-model="isAddDesc"
            persistent
            width="800px"
            max-width="800px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Add Description</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field
                            v-model="add_desc.descrank"
                            class="mb-4"
                            placeholder="Num"
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Num"
                            dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="10">
                            <v-select
                            class="mb-4"
                            :items="['Job Description', 'Skills & Qualifications', 'Education & Experience']"
                            v-model="add_desc.desctype"
                            placeholder="Type"
                            dense
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="12">
                            <vue-editor v-model="add_desc.desctext"></vue-editor>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isAddDesc=false; add_desc={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="addEmployeeDesc"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="isEditDesc"
            persistent
            width="800px"
            max-width="800px"
        >
            <v-card>
                <v-card-title>
                <span class="text-h5">Edit Description</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field
                            v-model="edit_desc.descrank"
                            class="mb-4"
                            placeholder="Num"
                            type="number"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Num"
                            dense
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="10">
                            <v-select
                            class="mb-4"
                            :items="['Job Description', 'Skills & Qualifications', 'Education & Experience']"
                            v-model="edit_desc.desctype"
                            placeholder="Type"
                            dense
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="12">
                            <vue-editor v-model="edit_desc.desctext"></vue-editor>
                        </v-col>
                    </v-row>
                </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="isEditDesc=false; edit_desc={}"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="editEmployeeDesc"
                >
                    Save
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions} from "vuex";
import { formatHtmlText } from '../../../util/tools';
export default {
    components: {
        VueEditor
    },
    props: {
        data: {
            type: Array
        },
        id: String,
    },
    data () {
        return {
            header_items: [
                { text: "#", value: "descrank", width: "10px" },
                { text: "Type", value: "desctype" },
                { text: "Actions", value: "actions", sortable: false , width: "10%"},
            ],
            data_descriptions: [],
            isAddDesc: false,
            isDeleteDesc: false,
            isEditDesc: false,
            add_desc: {},
            delete_desc: {},
            edit_desc: {},
            formatHtmlText: formatHtmlText,
        }
    },
    methods: {
        ...mapActions('Employee', [ 'insertEmployeeDescRequest', 'deleteEmployeeDescRequest', 'updateEmployeeDescRequest']),
        async addEmployeeDesc() {
            this.isAddDesc = false;
            this.add_desc.employeeid = this.id;
            console.log(this.add_desc)
            let result = await this.insertEmployeeDescRequest(this.add_desc);
            if(result!=null) this.data_descriptions.splice(0,0,result);
            this.add_desc = {};
        },
        deleteEmployeeDescDialog(item) {
            this.isDeleteDesc = true;
            this.delete_desc = { _id: item._id, desctype: item.desctype };
        },
        async deleteEmployeeDesc(item) {
            this.isDeleteDesc = false;
            let result = await this.deleteEmployeeDescRequest(item);
            let index = this.data_descriptions.findIndex((i) => i._id == result._id);
            this.data_descriptions.splice(index, 1);
        },
        editEmployeeDescDialog(item) {
            this.isEditDesc = true;
            this.edit_desc = Object.assign({},item);
        },
        async editEmployeeDesc() {
            this.isEditDesc = false;
            let result = await this.updateEmployeeDescRequest(this.edit_desc);
            let index = this.data_descriptions.findIndex((i)=> i._id == result._id);
            this.data_descriptions.splice(index, 1, result);
        },
    },
    created(){
        this.data_descriptions = Object.assign([], this.data);
    }
}
</script>